import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../../../../../services/languageUtils';
import ModalBase from './modalBase';

function ModalInfo ({ show, onClose }){
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations((localStorage.getItem('language') || 'pt'));
      setTranslations(trans);
    };
    loadTranslations();
  }, []);
  
  return (
    <ModalBase show={show} onClose={onClose}>
      <h1 className="text-2xl font-bold text-center">{translations.main_advantages_of_PIX}</h1><br/>
      <p><b>{translations.speed}</b> - {translations.transaction_completed_in_seconds}</p>
      <p><b>{translations.availability}</b> - {translations.any_day_any_time}</p>
      <p><b>{translations.convenience}</b> - {translations.simple_and_practical}</p>
      <p><b>{translations.cost}</b> - {translations.free_of_charge}, {translations.if_user_is_subject_to_fees} {translations.inform_the_cost}</p>
      <p><b>{translations.initiation_methods}</b> - {translations.key}, {translations.qr_code}</p><br/>
      <button
        onClick={onClose}
        className="w-full px-4 py-2 bg-customGreen text-white rounded hover:bg-customGreenHover"
      >
        {translations.proceed}
      </button>
    </ModalBase>
  );
}

export default ModalInfo;
